import { api } from './api';

const userSoftDelete = async (data) => {
  const response = await api({
    url: `Users/userSoftDelete`,
    method: 'PUT',
    data,
  });
  return response.data;
};

const userChangeStatus = async (data) => {
  const response = await api({
    url: `Users/userChangeStatus`,
    method: 'PUT',
    data,
  });
  return response.data;
};

const getUserContactLookup = async (data) => {
  const response = await api({
    url: `Users/getUserContactLookup`,
    method: 'GET',
    params: data,
  });
  return response.data;
};

const createUserAndRole = async (data) => {
  const response = await api({
    url: `Users/createUserAndRole`,
    method: 'POST',
    data,
  });
  return response.data;
};

const createUserManuelAndRole = async (data) => {
  const response = await api({
    url: `Users/createUserManuelAndRole`,
    method: 'POST',
    data,
  });
  return response.data;
};

const updateUserAndRole = async (data) => {
  const response = await api({
    url: `Users/updateUserAndRole`,
    method: 'POST',
    data,
  });
  return response.data;
};

const updateUserManuelAndRole = async (data) => {
  const response = await api({
    url: `Users/updateUserManuelAndRole`,
    method: 'POST',
    data,
  });
  return response.data;
};

const getUserInfo = async (data) => {
  const response = await api({
    url: `Users/getUserInfo`,
    method: 'GET',
    params: {
      userId: data.userId,
    },
  });
  return response.data;
};

const getListUserAddressLookup = async ({ body, PageNumber, PageSize }) => {
  const response = await api({
    url: 'UserAddresses/GetListUserAddressesLookup',
    method: 'GET',
    params: {
      page: PageNumber,
      pageSize: PageSize,
      ...body,
    },
  });
  return response.data;
};

const getUserAuthorizationStatus = async () => {
  const response = await api({
    url: `Users/getUserAuthorizationStatus`,
    id: 'Users-getUserAuthorizationStatus',
    method: 'GET',
    cache: {
      ttl: 15 * 60 * 1000,
    },
  });
  return response.data;
};

const getUserAuthorizationStatusGift = async () => {
  const response = await api({
    url: `Users/getUserAuthorizationStatusGift`,
    method: 'GET',
    cache: {
      ttl: 15 * 60 * 1000,
    },
  });
  return response.data;
};

const getUserAuthorizationStatusMarket = async () => {
  const response = await api({
    url: `Users/getUserAuthorizationStatusMarket`,
    method: 'GET',
    cache: {
      ttl: 15 * 60 * 1000,
    },
  });
  return response.data;
};

const usersServices = {
  userSoftDelete,
  userChangeStatus,
  getUserContactLookup,
  createUserAndRole,
  updateUserAndRole,
  getUserInfo,
  getListUserAddressLookup,
  createUserManuelAndRole,
  updateUserManuelAndRole,
  getUserAuthorizationStatus,
  getUserAuthorizationStatusGift,
  getUserAuthorizationStatusMarket,
};

export default usersServices;
